<template>
    <div class="card2">
        <a 
        class="card-inner" 
        v-for="(item,index) in homeCard" 
        :key="index" 
        target="_blank"
        :href="`/news/${item.guid}?search=${search.title}`"
        >
            <p class="title"> {{item.title}}</p>
            <div class="card2-cont">
                <p class="cont"> {{item.content}}</p>
                <p class="time">
                    <i class="el-icon-time"></i>
                    {{item.time}}
                </p>
            </div>
        </a>
    </div>
</template>

<script>
import { ToText } from '../assets/js/news.js';

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        search: {
            type: String,
            default: '',
        },
    },
    components: {
    },
    watch: {
        data: {
            handler(n) {
                this.handleData();
            },
            deep: true,
        },
    },

    data: () => ({
        homeCard: [],
    }),
    computed: {},
    mounted() {
        this.handleData();
    },
    methods: {
        gotoDetails(item) {
            this.$emit('goDetails', { guid: item.guid });
        },

        handleData() {
            let cardData = this.data.map((item) => {
                return {
                    title: item.articletitle,
                    content: ToText(item.mainbody),
                    time: item.fbdate,
                    guid: item.guid,
                };
            });
            this.homeCard = cardData;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.card2 {
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-bottom: 60px;

    .card-inner {
        display: block;
        width: 580px;
        height: 200px;
        padding: 30px 20px;
        margin: 15px 0;
        border: 1px solid #eaeaea;
        position: relative;
        background-color: white;

        .card2-cont {
            width: 100%;
            // display: flex;
            // justify-content: space-between;
        }
        &:hover {
            cursor: pointer;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
            transition: all 0.3s;
        }

        &:hover .title , &:hover .cont , &:hover .time {
            color: #8a1f94;
        }


        &:hover .card-bot {
            display: block;
        }

        .card-bot {
            position: absolute;
            bottom: 0;
            left: 0;
            display: none;
            width: 100%;
            height: 8px;
            background-color: #8a1f94;
        }

        img {
            display: inline-block;
            width: 150px;
            height: 105px;
            margin-bottom: 20px;
            overflow: hidden;
        }
        .time {
            font-size: 12px;
            color: #ababab;
        }
        .title {
            display: inline-block;
            height: 44px;
            font-size: 18px;
            font-weight: 600;
            color: #2e2f30;
            margin: 0 0 20px;
        }
        .cont {
            display: inline-block;
            width: 100%;
            min-height: 36px;
            margin-bottom: 20px;
            font-size: 14px;
            color: #454545;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
    }
}
</style>